import { gql } from '@apollo/client';

import type * as GraphQLTypes from '../../graphql/types.generated';
export type NetworksCreateOrganisationLocationMutationVariables = GraphQLTypes.Exact<{
  input: GraphQLTypes.CreateOrganisationLocationInput;
}>;

export type NetworksCreateOrganisationLocationMutationResult = { __typename?: 'Mutation' } & {
  networksCreateOrganisationLocation?: GraphQLTypes.Maybe<
    { __typename?: 'CreateOrganisationLocationPayload' } & {
      errors?: GraphQLTypes.Maybe<Array<{ __typename?: 'Error' } & Pick<GraphQLTypes.Error, 'message' | 'path'>>>;
      location?: GraphQLTypes.Maybe<{ __typename?: 'NetworksLocation' } & Pick<GraphQLTypes.NetworksLocation, 'id'>>;
      orgLoc?: GraphQLTypes.Maybe<
        { __typename?: 'NetworksOrgLoc' } & Pick<GraphQLTypes.NetworksOrgLoc, 'id' | 'timeZone'> & {
            contact?: GraphQLTypes.Maybe<
              { __typename?: 'NetworksOrgLocContact' } & Pick<
                GraphQLTypes.NetworksOrgLocContact,
                'email' | 'firstName' | 'id' | 'lastName' | 'phoneNumber'
              >
            >;
            label?: GraphQLTypes.Maybe<
              { __typename?: 'NetworksLabelType' } & Pick<GraphQLTypes.NetworksLabelType, 'long' | 'short'>
            >;
            location?: GraphQLTypes.Maybe<
              { __typename?: 'NetworksOrgLocLocation' } & Pick<GraphQLTypes.NetworksOrgLocLocation, 'id' | 'name'> & {
                  address?: GraphQLTypes.Maybe<
                    { __typename?: 'LegacyAddress' } & Pick<
                      GraphQLTypes.LegacyAddress,
                      'city' | 'countyOrState' | 'postalCodeOrZip' | 'street'
                    > & { country?: GraphQLTypes.Maybe<{ __typename?: 'Country' } & Pick<GraphQLTypes.Country, 'code' | 'name'>> }
                  >;
                  geolocation?: GraphQLTypes.Maybe<
                    { __typename?: 'Geolocation' } & Pick<GraphQLTypes.Geolocation, 'latitude' | 'longitude'>
                  >;
                }
            >;
            organisation?: GraphQLTypes.Maybe<
              { __typename?: 'NetworksOrgLocOrganisation' } & Pick<GraphQLTypes.NetworksOrgLocOrganisation, 'id' | 'name'>
            >;
          }
      >;
    }
  >;
};

export const NetworksCreateOrganisationLocationDocument = gql`
  mutation networksCreateOrganisationLocation($input: CreateOrganisationLocationInput!) {
    networksCreateOrganisationLocation(input: $input) {
      errors {
        message
        path
      }
      location {
        id
      }
      orgLoc {
        contact {
          email
          firstName
          id
          lastName
          phoneNumber
        }
        id
        label {
          long
          short
        }
        location {
          address {
            city
            country {
              code
              name
            }
            countyOrState
            postalCodeOrZip
            street
          }
          geolocation {
            latitude
            longitude
          }
          id
          name
        }
        organisation {
          id
          name
        }
        timeZone
      }
    }
  }
`;
